<template>
  <div class="section">
    <span class="title">{{ $t('RailwayExport.FirstLeglastLegInformation') }}</span>
    <cargo-ag-grid
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :row-data="finalRowData"
      style="width 100%;"
      @gridReady="params=>{gridApi=params.api}"
    />
    <div class="operations" style="margin-top: 5px;">
      <div v-show="cooperateEdit" class="triggers">
        <div>
          <el-button
            no="copyAndAddPoItems"
            type="primary"
            :disabled="readonly"
            @click="copyNewHandler"
          >{{ $t('SeaExport.copyAndAddPoItems') }}</el-button>
          <el-button
            no="Add"
            type="primary"
            :disabled="readonly"
            @click="addHandler"
          >{{ $t('SeaExport.Add2') }}</el-button>
          <el-button
            no="Delete"
            type="danger"
            :disabled="notEdit"
            @click="delHandler"
          >{{ $t('SeaExport.Delete') }}</el-button>
        </div>
      </div>
    </div>
    <el-form
      :disabled="notEdit"
      label-width="70px"
      label-position="left"
      style="margin-top: 15px;"
    >
      <el-form-item :label="$t('RailwayExport.FirstLeglastLeg')">
        <el-select v-model="form.headwayTail" no="headwayTail" :placeholder="notEdit ? '' : $t('CargoMsg.Cargo_PleaseSelect')" style="width: 190px;" @change="onFormChange">
          <el-option
            v-for="(item,index) in HEADWAY_TAIL_TYPES"
            :key="index"
            :label="item.chineseName"
            :value="item.code"
          />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('RailwayExport.TransportationMethod')">
        <el-select v-model="form.transportMethod" no="transportMethod" :placeholder="notEdit ? '' : $t('CargoMsg.Cargo_PleaseSelect')" style="width: 190px;" @change="onFormChange">
          <el-option
            v-for="(item,index) in TRANSPORT_METHOD_TYPES"
            :key="index"
            :label="item.chineseName"
            :value="item.code"
          />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('SeaExport.HaulageCompany')" class="auto-width">
        <cargo-company-select
          no="transportCompany"
          :method-params="{truckCmp:true,active:true}"
          :default-value="form.transportCompany||''"
          style="display: block;width: 280px;"
          @change="p=>{form.transportCompany=p.value;onFormChange()}"
        />
      </el-form-item>
    </el-form>
    <div style="display: flex;flex-direction: row;">
      <el-form :disabled="notEdit" label-width="70px" label-position="left">
        <el-form-item :label="$t('SeaExport.Trucking')">
          <cargo-advance-select
            no="region"
            :select-type="TYPE_NAMES.basic_data_Country"
            :default-value="form.region"
            filterable
            style="width: 190px;"
            @parentCallBack="p=>{form.region=p.value;onFormChange()}"
          />
        </el-form-item>
      </el-form>
      <el-form
        :disabled="notEdit"
        :inline="true"
        label-position="left"
        style="width: fit-content;margin-left: 30px;"
      >
        <cargo-area
          no="province"
          country="CN"
          :province.sync="form.province"
          :city.sync="form.city"
          :district.sync="form.districts"
        />
      </el-form>
    </div>
    <el-form :disabled="notEdit" :inline="true" label-width="70px" label-position="left" style="width: fit-content;">
      <el-form-item :label="$t('RailwayExport.ContactPerson')">
        <el-input v-model="form.contact" no="contact" @change="onFormChange" />
      </el-form-item>
      <el-form-item :label="$t('SeaExport.Tel')" label-width="36px">
        <el-input v-model="form.telephone" no="telephone" @change="onFormChange" />
      </el-form-item>
    </el-form>
    <el-form :disabled="notEdit" label-width="70px" label-position="left">
      <el-form-item :label="$t('RailwayExport.DetailedAddress')">
        <el-input
          v-model="form.address"
          no="address"
          type="textarea"
          :rows="3"
          style="width: 637px;"
          @change="onFormChange"
        />
      </el-form-item>
      <el-form-item :label="$t('SeaExport.AdditionalNotes')">
        <el-input
          v-model="form.remarks"
          no="remarks"
          type="textarea"
          :rows="3"
          style="width: 637px;"
          @change="onFormChange"
        />
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import cargoArea from '@/components/Cargo/Common/cargoArea'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { TabError } from '@/utils/class/TabError'
import ColumnUtils from '@/utils/ColumnUtils'
import { ensureExecuteSuccess } from '@/utils/commonUtil'
import { TYPES as HEADWAY_TAIL_TYPES, getHeadwayTailByCode } from '@/class/cargo/model/parameters/HeadwayTail'
import { TYPES as TRANSPORT_METHOD_TYPES, getTransportMethodByCode } from '@/class/cargo/model/parameters/TransportMethod'
import { RailwayExportJob } from '@/class/model/booking/RailwayExportJob'
import { RailwayHeadwayTail } from '@/class/model/booking/RailwayHeadwayTail'
import { Company } from '@/class/model/mdm/Company'
import { Customer } from '@/class/model/mdm/Customer'
import { getLoading } from '@/utils/utilBaseElement'

export default {
  name: 'TabRailwayHeadwayTail',
  components: { cargoAdvanceSelect, cargoCompanySelect, cargoArea },
  props: {
    context: { type: Object, required: true },
    action: { type: String, required: true },
    cooperateEdit: { type: Boolean, default: true } // 能否修改
  },
  data() {
    return {
      TYPE_NAMES,
      HEADWAY_TAIL_TYPES,
      TRANSPORT_METHOD_TYPES,
      job: new RailwayExportJob().fillDefaultValue().getData(),
      gridOptions: {
        rowSelection: 'single',
        onRowDataChanged: event => {
          /* 清除单选行 */
          this.selectedNode = null
          event.api.clearFocusedCell()
        },
        onCellFocused: event => {
          if (this.selectedNode) {
            if (event.rowIndex !== this.selectedNode.rowIndex) { // 行索引比较，避免循环执行
              // 若验证不通过，回退到上次选中
              if (!this.validate()) {
                event.api.setFocusedCell(this.selectedNode.rowIndex, event.columnApi.getAllDisplayedColumns()[0])
                return
              }
            } else {
              return
            }
          }
          const nodes = event.api.getRenderedNodes()
          this.selectedNode = nodes[event.rowIndex] || null
        },
        onSortChanged: event => {
          // 重置单选行
          if (this.selectedNode) {
            const rowIndex = this.selectedNode.rowIndex
            this.selectedNode = null
            event.api.setFocusedCell(rowIndex, event.columnApi.getAllDisplayedColumns()[0])
          }
        },
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: this.$t('RailwayExport.FirstLeglastLeg'),
          field: 'headwayTail',
          width: 120,
          cellRenderer: params => {
            const obj = getHeadwayTailByCode(params.value)
            return obj ? obj.chineseName : ''
          }
        },
        {
          headerName: this.$t('RailwayExport.TransportationMethod'),
          field: 'transportMethod',
          width: 120,
          cellRenderer: params => {
            const obj = getTransportMethodByCode(params.value)
            return obj ? obj.chineseName : ''
          }
        },
        {
          headerName: this.$t('SeaExport.HaulageCompany'),
          field: 'transportCompany',
          width: 150,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('RailwayExport.CustomerDoordestinationPortDoor'),
          colId: 'region-address',
          width: 180,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Country, 'code', params.data.region, 'chineseName') + ' ' + params.data.address
          }
        },
        {
          headerName: this.$t('RailwayExport.CustomerContactPerson'),
          field: 'contact',
          width: 120
        },
        {
          headerName: this.$t('SeaExport.Tel'),
          field: 'telephone',
          width: 100
        },
        {
          headerName: this.$t('SeaExport.AdditionalNotes'),
          field: 'remarks',
          width: 240
        }
      ],
      selectedNode: null,
      gridApi: null
    }
  },
  computed: {
    readonly() {
      if (!this.cooperateEdit) return true
      return this.action === 'look'
    },
    notEdit() {
      return this.readonly || !this.selectedNode
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look'
    },
    rowData() {
      return this.job.railwayHeadwayTails
    },
    finalRowData() {
      if (this.rowData) {
        return this.rowData.filter(p => !p.deleted)
      } else {
        return []
      }
    },
    form() {
      if (this.selectedNode) {
        return this.selectedNode.data
      } else {
        return new RailwayHeadwayTail().fillDefaultValue().getData()
      }
    }
  },
  methods: {
    async onShow(row, isRefresh) {
      if (!isRefresh) {
        return
      }
      this.job = row
      if (row.uuid && !row.railwayHeadwayTails) {
        const loading = getLoading()
        this.context.loading = true
        await new RailwayExportJob(row).loadJobRelated({ railwayHeadwayTails: true }).finally(() => {
          loading.close()
          this.context.loading = false
        })
      }
      // 等待gridApi被赋值
      await ensureExecuteSuccess(() => this.gridApi)
      if (this.rowData.length > 0) {
        setTimeout(() => {
          this.gridApi.setFocusedCell(0, this.gridApi.columnController.getAllDisplayedColumns()[0])
        }, 100)
      } else if (this.isEdit) {
        this.addHandler()
      }
    },
    getSubmitData() {
      if (this.selectedNode) {
        if (!this.form.headwayTail) {
          throw new TabError(this.$t('RailwayExport.FirstLegCannotBeEmpty'), 'tabRailwayHeadwayTail')
        }
        if (!this.form.transportCompany) {
          throw new TabError(this.$t('RailwayExport.PleaseEnterTransportationCompanyInformation'), 'tabRailwayHeadwayTail')
        }
      }
      return {
        railwayHeadwayTails: this.rowData
      }
    },
    async getPrintData() {
      const job = this.job
      const reqKeys = []
      const selectedKeysStr = job.satisfiedRequests
      if (selectedKeysStr) {
        const selectedKeys = selectedKeysStr.split(',')
        const cmp = this.context.companyList.find(p => p.cmpIdx === job.customerId)
        if (cmp) {
          const customerDetail = await new Company({ uuid: cmp.uuid }).getCustomerDetail()
          if (customerDetail) {
            const specialRequests = await new Customer(customerDetail).getSpecialRequests()
            for (const item of specialRequests) {
              if (item.lob === 'RE' || item.lob === 'ALL') {
                if (selectedKeys.includes(item.request)) {
                  reqKeys.push(item.uuid)
                }
              }
            }
          }
        }
      }
      const params = {}
      params.jobuuid = job.uuid
      params.JOB_UUID = job.uuid
      params.RAILWAYHEADWAYTAIL_UUID = this.form.uuid || null
      params.USER_ID = this.context.user.userId
      params.REQUEST_UUID = reqKeys.length === 0 ? '' : reqKeys
      params.category = 'RAILWAYHEADWAYTAIL'
      params.ctx = new RailwayExportJob(this.job)
      return params
    },
    copyNewHandler() {
      if (!this.selectedNode) {
        this.$message.warning(this.$t('RailwayExport.PleaseSelectDesignatedData'))
        return
      }
      if (this.validate()) {
        const newRow = new RailwayHeadwayTail().fillDefaultValue().getData()
        newRow.railwayExportJobUuid = this.job.uuid
        newRow.transportMethod = this.form.transportMethod
        newRow.transportCompany = this.form.transportCompany
        newRow.region = this.form.region
        newRow.province = this.form.province
        newRow.city = this.form.city
        newRow.districts = this.form.districts
        newRow.contact = this.form.contact
        newRow.telephone = this.form.telephone
        newRow.address = this.form.address
        newRow.remarks = this.form.remarks
        this.rowData.push(newRow)
        setTimeout(() => {
          this.gridApi.setFocusedCell(this.finalRowData.length - 1, this.gridApi.columnController.getAllDisplayedColumns()[0])
        }, 100)
      }
    },
    addHandler() {
      if (!this.selectedNode || this.validate()) {
        const newRow = new RailwayHeadwayTail().fillDefaultValue().getData()
        newRow.railwayExportJobUuid = this.job.uuid
        this.rowData.push(newRow)
        setTimeout(() => {
          this.gridApi.setFocusedCell(this.finalRowData.length - 1, this.gridApi.columnController.getAllDisplayedColumns()[0])
        }, 100)
      }
    },
    validate() {
      if (!this.form.headwayTail) {
        this.$message.warning(this.$t('RailwayExport.FirstLegCannotBeEmpty'))
        return false
      }
      if (!this.form.transportCompany) {
        this.$message.warning(this.$t('RailwayExport.PleaseEnterTransportationCompanyInformation'))
        return false
      }
      return true
    },
    onFormChange() {
      this.gridApi.refreshCells({ force: true })
    },
    delHandler() {
      const index = this.rowData.findIndex(p => p === this.form)
      if (index < 0) {
        return
      }
      if (this.form.uuid) {
        this.form.deleted = true
        /* 强制finalRowData刷新 */
        this.rowData.splice(index, 1)
        this.rowData.push(this.form)
      } else {
        this.rowData.splice(index, 1)
      }
      if (this.finalRowData.length > 0) {
        setTimeout(() => {
          this.gridApi.setFocusedCell(0, this.gridApi.columnController.getAllDisplayedColumns()[0])
        }, 100)
      }
    }
  }
}
</script>
